import {Label} from '@primer/react'

export function ThreadBadges({
  isResolved,
  isOutdated,
  className,
}: {
  isResolved?: boolean
  isOutdated?: boolean
  className?: string
}) {
  if (isResolved) {
    return (
      <Label variant="secondary" className={className}>
        Resolved
      </Label>
    )
  }

  if (isOutdated) {
    return (
      <Label variant="attention" className={className}>
        Outdated
      </Label>
    )
  }

  return null
}
